import { Close, SuccessIcon } from "lola-framework-ui-test";
import {
  TransactionsStatus,
  type TransactionsStatus as status,
} from "../utils/commons";
import { useTranslation } from "react-i18next";
import { useStore } from "../store/globalState";
import { amountFormatter } from "../utils";

export interface TransactionItemProps {
  operationId: string;
  status: status;
  amount: string;
  currency: string;
  date: string;
  onClick?: (operationId: string) => void;
}

export const TransactionItem: React.FC<TransactionItemProps> = ({
  operationId,
  status,
  amount,
  currency,
  date,
  onClick,
}) => {
  const { theme } = useStore();
  const { footerColor } = theme.dataView;
  const { t } = useTranslation();

  const generateStatus = () => {
    switch (status) {
      case TransactionsStatus.COMPLETED:
        return {
          label: TransactionsStatus.COMPLETED,
          icon: (
            <SuccessIcon
              size={10}
              className="flavor-c-icon"
              colors={[footerColor, footerColor]}
            />
          ),
        };
      case TransactionsStatus.CANCELED:
      case TransactionsStatus.CANCELLED:
        return {
          label: TransactionsStatus.CANCELLED,
          icon: (
            <Close
              size={10}
              className="flavor-c-icon"
              colors={[footerColor, footerColor]}
            />
          ),
        };
      default:
        return {
          label: status,
          icon: null,
        };
    }
  };

  const itemStatus = generateStatus();

  const handleClick = () => {
    if (onClick) {
      onClick(operationId);
    }
  };

  return (
    <section
      className="transactions-history-item gradient-card"
      onClick={handleClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <p className="transactions-avatar  shadow-glow">
        {t("transactions.avatar")}
      </p>
      <section className="transactions-info">
        <div className="transactions-row transactions-row--primary">
          <p className="transaction-title foreground">
            <b>{t("transactions.transfers")}</b>
          </p>
          <p className="transactions-amount foreground">
            <b>
              ${amountFormatter(parseFloat(amount), currency)} {currency}
            </b>
          </p>
        </div>
        <div className="transactions-row transactions-row--meta">
          <section className="transactions-status">
            {itemStatus.icon}
            <p className="transactions-status-label muted-foreground">
              {t(`receiptSummary.fields.status.items.${itemStatus.label.toLocaleLowerCase()}`)}
            </p>
          </section>
          <p className="transactions-date muted-foreground">{date}</p>
        </div>
      </section>
    </section>
  );
};
